import FieldsConstants from '../../common/fields.constants';

export class FileType {
  public isImage(contentType: string): boolean {
    // For a browser that does not support HEIC format, the file has to be considered as an unsupported type
    if (this.isHeic(contentType)) {
      return this.isSafari();
    }

    return contentType.indexOf('image/') === 0;
  }

  public isPdf(contentType: string): boolean {
    return contentType.indexOf('application/pdf') === 0;
  }

  public isDoc(contentType: string): boolean {
    return FieldsConstants.EXTENSION_MIME_TYPE.includes(contentType);
  }

  public isVideo(contentType: string): boolean {
    return contentType.indexOf('video/') === 0;
  }

  public isAudio(contentType: string): boolean {
    return contentType.indexOf('audio/') === 0;
  }

  private isHeic(contentType: string): boolean {
    return contentType.indexOf('image/heic') === 0;
  }

  private isSafari(): boolean {
    return this.getBrowserName() === 'Safari';
  }

  private getBrowserName(): string {
    const agent = window.navigator.userAgent.toLowerCase();
    const browser =
      agent.indexOf('edge') > -1
        ? 'Microsoft Edge'
        : agent.indexOf('edg') > -1
          ? 'Chromium-based Edge'
          : agent.indexOf('opr') > -1
            ? 'Opera'
            : agent.indexOf('chrome') > -1
              ? 'Chrome'
              : agent.indexOf('trident') > -1
                ? 'Internet Explorer'
                : agent.indexOf('firefox') > -1
                  ? 'Firefox'
                  : agent.indexOf('safari') > -1
                    ? 'Safari'
                    : 'other';

    return browser;
  }
}
